// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {GetCustomerVouchersSuccess} from 'redux/v1/customerVouchers/actions';
import type {CustomerVouchersState} from 'redux/v1/customerVouchers/CustomerVouchersState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  PURE,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {
  GET_CUSTOMER_VOUCHERS,
  RESET_CUSTOMER_VOUCHERS,
} from 'redux/v1/customerVouchers/actions';
import {customerVouchersState} from 'redux/v1/V1State';

export const initialState: CustomerVouchersState = {
  loading: false,
};

const actionCreators: ActionHandlers<CustomerVouchersState> = {
  [PENDING(GET_CUSTOMER_VOUCHERS)]: (state: CustomerVouchersState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(GET_CUSTOMER_VOUCHERS)]: (
    state: CustomerVouchersState,
    action: GetCustomerVouchersSuccess
  ) => ({
    ...state,
    loading: false,
    vouchers: action.data === undefined ? null : action.data,
  }),
  [ERROR(GET_CUSTOMER_VOUCHERS)]: (
    state: CustomerVouchersState,
    action: any
  ) => ({
    ...state,
    loading: false,
    error: action.error,
  }),
  [PURE(RESET_CUSTOMER_VOUCHERS)]: (
    state: CustomerVouchersState,
    action: any
  ) => initialState,
};

// $FlowIgnore
export const customerVouchersReducer: Reducer<CustomerVouchersState> =
  // $FlowIgnore
  createReducerUsingActionHandlers<CustomerVouchersState>(
    initialState,
    actionCreators
  );

export const isLoaded: Selector<Boolean> = createSelector(
  customerVouchersState,
  (state: CustomerVouchersState) =>
    !state.loading &&
    (state.vouchers !== undefined ||
      state.error !== undefined)
);

export const getCustomerVouchers: Selector<string | void> = createSelector(
  customerVouchersState,
  (state: CustomerVouchersState) => state?.vouchers || null
);
